// extracted by mini-css-extract-plugin
export default {"signOffItem":"styles_signOffItem__mK91E","detailsList":"styles_detailsList__RDjkD","signOffDate":"styles_signOffDate__8bsWb"};